import React from "react";
import { useLocation } from "react-router-dom";
import paths from "routes/paths";
import { useAppSelector } from "store";
import { authNewSelectors } from "store/reducers/auth-new";

import CreditLow from "./credit-low";
import SubscriptionCanceling from "./subscription-canceling";
import SubscriptionCreditLow from "./subscription-credit-low";
import { SubscriptionEnterpriseNoAutoRefill } from "./subscription-enterprise-no-auto-refill";
import SubscriptionPastDue from "./subscription-past-due";
import SubscriptionTrialActive from "./subscription-trial-active";
import { TrialAvailable } from "./trial-available";

const TopAlert = () => {
  const autorefill = useAppSelector(
    authNewSelectors.teamSettingCreditAutoRefillThresholdPercentageGet,
  );
  const creditLeft = useAppSelector(authNewSelectors.creditLeftGet);
  const creditLowShow = useAppSelector(authNewSelectors.creditLowShowGet);
  const subscription = useAppSelector(authNewSelectors.subscriptionGet);
  const trialAvailable = useAppSelector(authNewSelectors.trialAvailableGet);
  const { pathname } = useLocation();

  if (
    pathname.startsWith("/purchase") ||
    pathname === paths.settingsBillingTrialConvert()
  ) {
    return null;
  }

  if (subscription) {
    if (subscription.plan.enterprise && autorefill == null) {
      return <SubscriptionEnterpriseNoAutoRefill />;
    }

    if (subscription.cancelAt && !subscription.plan.enterprise) {
      return <SubscriptionCanceling cancelAt={subscription.cancelAt} />;
    }

    if (subscription.pastDue) {
      return <SubscriptionPastDue />;
    }

    if (subscription.trialEndAt) {
      return (
        <SubscriptionTrialActive
          endAt={subscription.trialEndAt}
          subscription={subscription}
        />
      );
    }

    if (creditLowShow) {
      return <SubscriptionCreditLow />;
    }
  }

  if (trialAvailable) {
    return <TrialAvailable />;
  }

  if (creditLeft === 0) {
    return <CreditLow />;
  }

  return null;
};

export default TopAlert;
